module.exports = __webpack_public_path__ + "img/adchoices.94a40edc.svg";